var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 3.35547C3.10697 3.35547 3.55469 2.90775 3.55469 2.35547C3.55469 1.80318 3.10697 1.35547 2.55469 1.35547C2.0024 1.35547 1.55469 1.80318 1.55469 2.35547C1.55469 2.90775 2.0024 3.35547 2.55469 3.35547Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 9.35547C3.10697 9.35547 3.55469 8.90775 3.55469 8.35547C3.55469 7.80318 3.10697 7.35547 2.55469 7.35547C2.0024 7.35547 1.55469 7.80318 1.55469 8.35547C1.55469 8.90775 2.0024 9.35547 2.55469 9.35547Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 15.3555C3.10697 15.3555 3.55469 14.9078 3.55469 14.3555C3.55469 13.8032 3.10697 13.3555 2.55469 13.3555C2.0024 13.3555 1.55469 13.8032 1.55469 14.3555C1.55469 14.9078 2.0024 15.3555 2.55469 15.3555Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 3.35547C9.10697 3.35547 9.55469 2.90775 9.55469 2.35547C9.55469 1.80318 9.10697 1.35547 8.55469 1.35547C8.0024 1.35547 7.55469 1.80318 7.55469 2.35547C7.55469 2.90775 8.0024 3.35547 8.55469 3.35547Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 9.35547C9.10697 9.35547 9.55469 8.90775 9.55469 8.35547C9.55469 7.80318 9.10697 7.35547 8.55469 7.35547C8.0024 7.35547 7.55469 7.80318 7.55469 8.35547C7.55469 8.90775 8.0024 9.35547 8.55469 9.35547Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 15.3555C9.10697 15.3555 9.55469 14.9078 9.55469 14.3555C9.55469 13.8032 9.10697 13.3555 8.55469 13.3555C8.0024 13.3555 7.55469 13.8032 7.55469 14.3555C7.55469 14.9078 8.0024 15.3555 8.55469 15.3555Z",
    fill: "#353E5A",
    stroke: "#353E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.3ea4a60dfdcb3ee49d750b38cf4d633f.svg";
export { ForwardRef as ReactComponent };